import React from 'react';

export const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">Terms of Service</h1>
            <p className="text-gray-600 mb-12">Last updated: January 2025</p>

            <div className="space-y-8 text-gray-700 leading-relaxed">
              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Agreement to Terms</h2>
                <p>
                  By accessing or using Global Mark Registry's services, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access our services.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Services Description</h2>
                <p className="mb-4">
                  Global Mark Registry provides trademark registration, copyright registration, company formation, and related intellectual property services. Our services include:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Trademark search and analysis</li>
                  <li>Trademark application preparation and filing</li>
                  <li>USPTO correspondence and office action responses</li>
                  <li>Copyright registration services</li>
                  <li>Company formation and business entity services</li>
                  <li>Amazon Brand Registry enrollment assistance</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">No Guarantee of Results</h2>
                <p>
                  While we strive for excellence and have a high success rate, we cannot guarantee that any trademark application will be approved by the USPTO. Trademark registration decisions are made solely by the USPTO based on their examination standards and existing trademark registrations.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Fees and Payments</h2>
                <p className="mb-4">
                  Our service fees are separate from government filing fees charged by the USPTO or other agencies. Payment terms include:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Service fees are due upon engagement and are non-refundable once work begins</li>
                  <li>Government filing fees are non-refundable regardless of application outcome</li>
                  <li>Additional fees may apply for office action responses or appeals</li>
                  <li>All fees must be paid in full before filing applications</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Client Responsibilities</h2>
                <p className="mb-4">You agree to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide accurate and complete information</li>
                  <li>Respond promptly to our requests for information</li>
                  <li>Review all documents before filing and approve submissions</li>
                  <li>Inform us of any changes to your contact information</li>
                  <li>Use your trademark in commerce as represented in your application</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Intellectual Property</h2>
                <p>
                  All content on our website, including text, graphics, logos, and software, is the property of Global Mark Registry or its licensors and is protected by copyright and trademark laws. You may not use, reproduce, or distribute any content without our express written permission.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Confidentiality</h2>
                <p>
                  We maintain strict confidentiality regarding your trademark applications and business information. All information you provide is treated as confidential and will not be disclosed to third parties except as required for service delivery or by law.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Limitation of Liability</h2>
                <p>
                  To the maximum extent permitted by law, Global Mark Registry shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services. Our total liability shall not exceed the amount you paid for our services.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Attorney-Client Relationship</h2>
                <p>
                  Use of our services may create an attorney-client relationship with respect to specific trademark matters. However, general information provided on our website or in consultations does not constitute legal advice or create an attorney-client relationship.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Termination</h2>
                <p>
                  Either party may terminate the service relationship with written notice. Upon termination, you remain responsible for all fees incurred prior to termination. We will provide you with all work product and documents in our possession.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Dispute Resolution</h2>
                <p>
                  Any disputes arising from these terms or our services shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. You waive any right to participate in class action lawsuits.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Governing Law</h2>
                <p>
                  These Terms of Service are governed by the laws of the United States, without regard to conflict of law principles. Any legal action must be brought in the appropriate federal or state courts.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Changes to Terms</h2>
                <p>
                  We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services constitutes acceptance of the modified terms.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Contact Information</h2>
                <p className="mb-4">
                  If you have questions about these Terms of Service, please contact us:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p><strong>Global Mark Registry</strong></p>
                  <p>Email: legal@mytmbrand.com</p>
                  <p>Phone: +1 (844) 205 0123</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};